import { FC, ReactNode } from 'react';

interface SubmissionListProps {
  title: string;
  children: ReactNode;
}

export const SubmissionList: FC<SubmissionListProps> = ({ title, children }) => (
  <div className="flex flex-col gap-2">
    <h5 className="[font-size:var(--fs-l3)]! lg:[font-size:var(--fs-l2)]! font-bold text-(--neutral-black-NB1000)! m-0!">
      {title}
    </h5>
    <div className="flex flex-col gap-2">{children}</div>
  </div>
);
